import classnames from "classnames";
import React from "react";

import { ProductPrice } from "@components/Product/Layout/ProductPrice/productPrice.component";

type PriceProps = {
    showStrippedPrice: boolean;
    showConvertedPriceAsMainPrice: boolean;
    strikethroughPrice?: number | null;
    conversionPrice?: number | null;
    conversionUnit?: string | null;
    currentConversionPrice?: number | null;
    salesPrice?: number | null;
    className?: string;
};

const Price = ({
    showStrippedPrice,
    showConvertedPriceAsMainPrice,
    conversionUnit,
    conversionPrice,
    strikethroughPrice,
    currentConversionPrice,
    salesPrice,
    className,
}: PriceProps) => {
    const getStrippedPrice = () => {
        if (!showStrippedPrice) return null;

        return showConvertedPriceAsMainPrice ? (
            <ProductPrice
                price={conversionPrice!}
                conversionPriceActive={true}
                conversionUnit={conversionUnit}
                variant={"promo"}
            />
        ) : (
            <ProductPrice price={strikethroughPrice!} variant={"promo"} />
        );
    };

    const getPrice = () => {
        return showConvertedPriceAsMainPrice ? (
            <ProductPrice
                price={currentConversionPrice!}
                conversionPriceActive={true}
                conversionUnit={conversionUnit}
                size={"medium"}
            />
        ) : (
            <ProductPrice price={salesPrice!} size={"medium"} />
        );
    };

    return (
        <div
            className={classnames(
                className,
                "d-flex flex-column align-items-end",
            )}
        >
            {getStrippedPrice()}
            {getPrice()}
        </div>
    );
};

export default Price;
